import { Action } from 'redux'
import { PlayerAchievementList, PlayerAchievementView } from '../../communication/PlayerApiProtocol.generated'
import {
	assign,
	AsyncState,
	AsyncStatus,
	createAsyncState,
	handleAsyncError,
	handleAsyncRequest,
	ReduxAction,
} from '../ReduxUtils'
import { ACHIEVEMENTS_ERROR, RECEIVE_ACHIEVEMENTS, REQUEST_ACHIEVEMENTS } from './AchievementsActions'
import { Feature, userFeatureService } from '../../services/UserFeatureService'

export interface AchievementState extends AsyncState {
    achievements?: PlayerAchievementView[];
}

const initialAchievements: AchievementState = createAsyncState({ achievements : []})
/**
 * Reducer for AchievementState part of the application state
 */
export function achievementReducer(state: AchievementState = initialAchievements, anAction: Action): AchievementState {
	const action: ReduxAction<any> = anAction as ReduxAction<any>
	switch (action.type) {
	case REQUEST_ACHIEVEMENTS:
		return handleAsyncRequest(state, action)
	case ACHIEVEMENTS_ERROR:
		return handleAsyncError(state)
	case RECEIVE_ACHIEVEMENTS:
		const achievements = sortAchievementsByOrder((action.payload as PlayerAchievementList).achievements)
			.filter(achievement => userFeatureService.doesUserHaveFeature(Feature.SWEEPS_ACHIEVEMENTS) ? true : !isScAchievement(achievement))

		return assign<AchievementState>({}, state, {
			achievements: achievements,
			status: AsyncStatus.COMPLETED,
			lastReceived: action.createdTime,
		})
	default:
		return state
	}
}

export function sortAchievementsByOrder(achievements : PlayerAchievementView[]) {
	let target = []
	if (achievements && achievements.length>0) {
		target = achievements.concat().sort(function(a,b){
			var aOrder = a.order!=null ? a.order : 0
			var bOrder = b.order!=null ? b.order : 0
			return bOrder - aOrder
		})
	}
	return target
}

export function isScAchievement(achievement: PlayerAchievementView): boolean {
	const sweepsTerms = ['sc', 'sweeps', 'xsd']

	for (const term of sweepsTerms) {
		if (achievement.achievementNameId && achievement.achievementNameId.toLowerCase().includes(term)) return true
		if (achievement.name && achievement.name.toLowerCase().includes(term)) return true
		if (achievement.description && achievement.description.toLowerCase().includes(term)) return true
		if (achievement.rewardDescription && achievement.rewardDescription.toLowerCase().includes(term)) return true
	}
	return false
}
